import React from "react";
import { MdEmail, MdLocalPhone } from "react-icons/md";
import Footer from "../Footer/Footer";
import { ContactForm } from "./ContactForm";
import ContactInfoItems from "./ContactInfoItems";



const HireMe = () => {
  return (
    <div className=" bg-purple-800 h-full pb-28">
      <div className=" title text-white flex flex-col items-center justify-center  pt-1 gap-1">
        <span className="mx-3 py-1 px-7 bg-gradient-to-r from-indigo-700 ... w-auto h-auto rounded-lg text-white text-xs mt-20">
          Here is my contact information if you want talk me or
        </span>
        <div className=" bg-pink-600 w-auto py-1  h-9 rounded-lg text-white  text-center px-1 text-lg">
          Hire Me
        </div>
      </div>

      <div className=" lg:flex lg:justify-center mt-4">
        <div className="left flex gap-1 flex-col mt-4 justify-start items-start ">
       
        
          <ContactInfoItems icon={<MdLocalPhone />} text="+573215864224" />
          <ContactInfoItems
            icon={<MdEmail />}
            text="luismiguelcm2015@gmail.com"
          />
          <ContactInfoItems text="Albania, La Guajira - Colombia." />
        </div>
        <div className="vertical-line lg:bg-pink-600 lg:w-0.5 lg:h-64 lg:mx-20 "></div>
        <div className=" bg-pink-600 h-0.5 mx-4"></div>
        <div className="right flex gap-1 flex-col mt-4">
        <ContactForm /> 
        </div>
        
        
       
      </div>
      <Footer />
       
    </div>
  );
};

export default HireMe;
